import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-38b97354"), n = n(), _popScopeId(), n); };
var _hoisted_1 = ["id"];
var _hoisted_2 = ["id"];
var _hoisted_3 = ["aria-expanded", "data-accordion-target", "aria-controls"];
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("svg", {
    "data-accordion-icon": "",
    class: "w-6 h-6 rotate-180 shrink-0",
    fill: "currentColor",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
        "clip-rule": "evenodd"
    })
], -1); });
var _hoisted_5 = ["id", "aria-labelledby"];
import { onMounted, onUpdated, ref } from "vue";
import CollapsibleContainer from "@/layout/collapsible/CollapsibleContainer.vue";
import { initAccordions } from "flowbite";
import { storeToRefs } from "pinia";
import { patientStore } from "@/store/patient";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollapsibleItem',
    props: {
        data: Object,
    },
    emits: ["rowActions", "create-form", "search"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var btnCollapsable = ref(null);
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var isOpen = ref(false);
        // initialize components based on data attribute selectors
        onMounted(function () {
            var _a, _b, _c, _d, _e, _f;
            if (store.collapsableStatus[((_a = props.data) === null || _a === void 0 ? void 0 : _a.data) + ((_b = props.data) === null || _b === void 0 ? void 0 : _b.filterValue)] == null) {
                store.collapsableStatus[((_c = props.data) === null || _c === void 0 ? void 0 : _c.data) + ((_d = props.data) === null || _d === void 0 ? void 0 : _d.filterValue)] = false;
            }
            isOpen.value = store.collapsableStatus[((_e = props.data) === null || _e === void 0 ? void 0 : _e.data) + ((_f = props.data) === null || _f === void 0 ? void 0 : _f.filterValue)];
            initAccordions();
        });
        function updateStatus() {
            var _a, _b;
            isOpen.value = !isOpen.value;
            store.collapsableStatus[((_a = props.data) === null || _a === void 0 ? void 0 : _a.data) + ((_b = props.data) === null || _b === void 0 ? void 0 : _b.filterValue)] = isOpen.value;
        }
        function search(word, check) {
            emit('search', word, check);
        }
        function createForm() {
            emit("create-form");
        }
        function action(type, row, index) {
            emit("rowActions", type, row, index);
        }
        onUpdated(function () {
            initAccordions();
        });
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            return (_openBlock(), _createElementBlock("div", {
                id: 'accordion-collapse-' + ((_a = __props.data) === null || _a === void 0 ? void 0 : _a.data) + ((_b = __props.data) === null || _b === void 0 ? void 0 : _b.filterValue),
                "data-accordion": "open",
                class: "colcontainer"
            }, [
                _createElementVNode("h2", {
                    id: 'accordion-collapse-heading-' + ((_c = __props.data) === null || _c === void 0 ? void 0 : _c.data) + ((_d = __props.data) === null || _d === void 0 ? void 0 : _d.filterValue)
                }, [
                    _createElementVNode("button", {
                        ref_key: "btnCollapsable",
                        ref: btnCollapsable,
                        onClick: updateStatus,
                        type: "button",
                        "aria-expanded": isOpen.value,
                        class: "collapsible flex items-center justify-between w-full p-5 font-medium text-right text-gray-500 rounded-t-xl dark:text-gray-400",
                        "data-accordion-target": '#accordion-collapse-body-' + ((_e = __props.data) === null || _e === void 0 ? void 0 : _e.data) + ((_f = __props.data) === null || _f === void 0 ? void 0 : _f.filterValue),
                        "aria-controls": 'accordion-collapse-body-' + ((_g = __props.data) === null || _g === void 0 ? void 0 : _g.data) + ((_h = __props.data) === null || _h === void 0 ? void 0 : _h.filterValue)
                    }, [
                        _createElementVNode("span", null, [
                            _createElementVNode("div", {
                                class: _normalizeClass((_j = __props.data) === null || _j === void 0 ? void 0 : _j.dotColor)
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString((_k = __props.data) === null || _k === void 0 ? void 0 : _k.title), 1)
                        ]),
                        _renderSlot(_ctx.$slots, "additional_button"),
                        _hoisted_4
                    ], 8, _hoisted_3)
                ], 8, _hoisted_2),
                _createElementVNode("div", {
                    id: 'accordion-collapse-body-' + ((_l = __props.data) === null || _l === void 0 ? void 0 : _l.data) + ((_m = __props.data) === null || _m === void 0 ? void 0 : _m.filterValue),
                    class: "hidden",
                    "aria-labelledby": 'accordion-collapse-heading-' + ((_o = __props.data) === null || _o === void 0 ? void 0 : _o.data) + ((_p = __props.data) === null || _p === void 0 ? void 0 : _p.filterValue)
                }, [
                    _createVNode(CollapsibleContainer, {
                        onRowActions: action,
                        onCreateForm: _cache[0] || (_cache[0] = function ($event) { return (createForm()); }),
                        data: __props.data,
                        class: "containerItem",
                        onSearch: _cache[1] || (_cache[1] = function (w, c) { return search(w, c); })
                    }, null, 8, ["data"]),
                    _renderSlot(_ctx.$slots, "default")
                ], 8, _hoisted_5)
            ], 8, _hoisted_1));
        };
    }
});
